import axios from 'axios';

export default class ChangePasswordService {
    static getUrl = url => process.env.baseHref + url;

    static getConnectedDevices() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/online/v1/sessions/devices')
        });
    }

    static getConnectedApps() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/online/v1/sessions/app-specific')
        });
    }

    static checkIsPasswordProhibited(newPassword) {
        return axios({
            method: 'PUT',
            url: this.getUrl('/api/user/v1/settings/is-password-prohibited'),
            data: { newPassword }
        });
    };

    static updatePassword(currentPassword, newPassword) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/user/v1/settings/password'),
            data: { currentPassword, newPassword }
        });
    };
}




// WEBPACK FOOTER //
// ./src/scripts/services/changePasswordService.js